"use client";

import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specifications = [{
  spec: "Materials",
  details: "Cast acrylic sheet — clear, frosted, white, black, colored, two-color laminate, all colors are available for materials"
}, {
  spec: "Thicknesses",
  details: "1/16\", 1/8\", 3/16\", 1/4\", 3/8\", 1/2\", 1\" - other thicknesses on request"
}, {
  spec: "Max sheet size",
  details: "48\" x 96\" — custom panel sizes and all custom shapes are available"
}, {
  spec: "Cut tolerance",
  details: "±0.005\" typical for laser cutting"
}, {
  spec: "Engraving depth",
  details: "Surface engraving standard · Through-engraving on two-color laminate"
}, {
  spec: "Shapes",
  details: "Rectangular, square, round, oval, custom cut-to-shape from DXF/AI file"
}, {
  spec: "Mounting options",
  details: "Adhesive backing · Pre-drilled holes · Standoff-ready · Slot or keyhole mount"
}, {
  spec: "Lead time",
  details: "2–5 business days standard · rush available"
}, {
  spec: "File formats accepted",
  details: "DXF, PDF, AI (Adobe Illustrator), SVG, EPS"
}, {
  spec: "Minimum order",
  details: "No minimum — single pieces quoted same as production runs"
}];
export default function AcrylicSpecifications() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="acrylictechnicalspecifications" className="bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-4xl px-4 md:px-6">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <div className="mb-10 text-center md:mb-12">
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
              Acrylic Cutting and Engraving — At a Glance
            </h2>
            <div className="mx-auto mt-4 h-1 w-16 bg-primary rounded-md"></div>
          </div>

          <div className="overflow-hidden rounded-lg border border-border bg-card shadow-md">
            <Table>
              <TableHeader className="bg-secondary/5">
                <TableRow className="hover:bg-transparent border-border">
                  <TableHead className="w-1/3 font-default text-base font-semibold text-foreground">
                    Specification
                  </TableHead>
                  <TableHead className="font-default text-base font-semibold text-foreground">
                    Details
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {specifications.map((item, i) => <TableRow key={i} data-index={i} className="border-border transition-colors hover:bg-muted/50">
                    <TableCell className="align-top font-medium text-foreground py-4">
                      {item.spec}
                    </TableCell>
                    <TableCell className="text-muted-foreground py-4 leading-relaxed">
                      {item.details}
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </section>;
}